import React from "react";

export function usePasscode(isVisible, confirmLoading) {
    const [passcode, setPasscode] = React.useState(null);
    const passcodeRef = React.useRef(null);

    // componentDidUpdate for isVisible
    React.useEffect(() => {
        if (!isVisible)
            setPasscode(null);

        if (isVisible) {
            setTimeout(() => {
                if (passcodeRef.current)
                    passcodeRef.current.focus();
            }, 1);
        }
    }, [isVisible]);

    React.useEffect(() => {
        if (isVisible && !confirmLoading)
            setPasscode(null);
    }, [isVisible, confirmLoading]);

    return [passcode, setPasscode, passcodeRef];
}
